module.exports = __webpack_public_path__ + "img/ls.9fc380a6.svg";